import {Box, Button, Grid, Typography} from '@material-ui/core';
import {capitalize} from 'components/forms/locale/utils';

const ProQuestion = ({section}) => {
    const emailSubjectTemplate = encodeURIComponent(`MM-SEAS ${capitalize(section)} License Question`);
    const emailBodyTemplate = encodeURIComponent(`Help! I wasn't able to find an answer to my question on the ${capitalize(
        section
    )} License FAQ page.`);

    return (
        <Grid container direction='column' justifyContent='center' align='center'>
            <Typography variant='h6' component='div'>
                Couldn’t find the answer to your question?
            </Typography>
            <Box maxWidth='40em' margin='1em auto'>
                <Box marginBottom='1em'>
                    <Typography>
                        Send us an email and we will answer it at at the next daily
                        live master classes and office hours Monday thru Friday from
                        5:00 - 5:30 pm PT.
                    </Typography>
                </Box>
                <Typography>
                    Also look for the weekly FAQ email on Monday afternoons which
                    covers the last weeks most common questions
                </Typography>
            </Box>
            <Grid item>
                <Button
                    href={`mailto:capt_nate_pro@mmseas.com?subject=${emailSubjectTemplate}&body=${emailBodyTemplate}`}
                    target='_blank'
                    variant='contained'
                    size='large'
                    color='secondary'
                >
                    Submit to capt_nate_pro@mmseas.com
                </Button>
            </Grid>
        </Grid>
    );
};

export default ProQuestion;
